import Image from "next/image";
import { useTeamConfig } from "./TeamConfigProvider";
import { Stack } from "@mui/material";
import { extractUrlParams } from "src/utils/utils";
import { useRouterExt } from "../hooks/useRouterExt";
import { routes } from "src/shared/routes";
import { blurDataURL } from "src/components/base/blur-data-url";
import { NextImage } from "src/components/base/components/NextImage";

export function LogoImage(props: { onClick?: () => void; src: string }) {
  const router = useRouterExt();
  const teamConfig = useTeamConfig();
  const { TEAM_GLOBAL_SETTINGS } = teamConfig;
  const logoUrlParams = extractUrlParams(
    props.src || teamConfig.IMAGES.LOGO_URL
  );

  const handleClick = async () => {
    // if onClick is provided via props, override the default behavior
    if (props?.onClick) return await props?.onClick();

    // else default behavior
    const urlCode = router?.query?.urlCode;
    router.pushSchema({
      pathname: TEAM_GLOBAL_SETTINGS?.DEFAULT_APP_ROUTE || routes.landing,
      query: { ...(urlCode && { urlCode }) },
    });
  };

  return (
    <Stack
      width={logoUrlParams?.width || "56px"}
      height={logoUrlParams?.height || "56px"}
      sx={{ WebkitTapHighlightColor: "transparent" }}
    >
      <NextImage
        alt={`${teamConfig.TEAM_FULL_NAME} Logo`}
        src={props.src}
        width={logoUrlParams?.width || 56}
        height={logoUrlParams?.height || 56}
        style={{
          width: logoUrlParams?.width || "100%",
          height: logoUrlParams?.height || "100%",
          objectFit: "contain",
          cursor: props.onClick ? "pointer" : "default",
          overflow: "visible",
          borderRadius: "4px",
        }}
        loading="lazy"
        placeholder="blur"
        blurDataURL={blurDataURL}
        onClick={handleClick}
      />
    </Stack>
  );
}
